import type {Site, SiteLandingPage} from 'src/types/page-site';
import type {Page} from 'src/types/landing-page';

import type {SitesActions} from 'src/action-creators/page-site';
import {PAGE_SITE_CONSTANTS} from 'src/action-creators/page-site';


const pageInitialState = {
  name: '',
  description: '',
  entity_type: 'candidate_lead',
  form_ids: [],
  url: '',
} as const;

export type PageSiteState = {
  page_sites: Site[];
  site_detail: Site;
  page: SiteLandingPage | null | undefined;
};

const initialState = {
  page_sites: null,
  site_detail: null,
  page: pageInitialState,
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly page_sites: null; readonly site_detail: null; readonly page: { readonly name: ""; readonly description: ""; readonly entity_type: "candidate_lead"; readonly form_ids: readonly []; readonly url: ""; }; }' is not assignable to type 'PageSiteState'.
  state: PageSiteState | null | undefined = initialState,
  action: SitesActions,
): PageSiteState => {
  switch (action.type) {
    case PAGE_SITE_CONSTANTS.FETCH_SITES: {
      // @ts-expect-error - TS2322 - Type '{ page_sites: Site[]; site_detail?: Site | undefined; page?: SiteLandingPage | null | undefined; }' is not assignable to type 'PageSiteState'.
      return {
        ...state,
        page_sites: action.payload,
      };
    }
    case PAGE_SITE_CONSTANTS.FETCH_SITE_DETAIL: {
      // @ts-expect-error - TS2322 - Type '{ site_detail: Site; page_sites?: Site[] | undefined; page?: SiteLandingPage | null | undefined; }' is not assignable to type 'PageSiteState'.
      return {
        ...state,
        site_detail: action.payload,
      };
    }
    case PAGE_SITE_CONSTANTS.UPDATE_SITE_DETAIL:
      // @ts-expect-error - TS2322 - Type '{ site_detail: { id?: number | null; name?: string; description?: string; domain_configuration?: { id: string; domain: string; subdomain?: string; }; url?: string; final_url?: string; ... 10 more ...; analytics?: { enabled: boolean; type: "GA" | "GTM"; gid: string; }; }; page_sites?: Site[] | undefined; page?: SiteL...' is not assignable to type 'PageSiteState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        site_detail: {...state.site_detail, ...action.payload},
      };
    case PAGE_SITE_CONSTANTS.RESET_SITE_DETAIL: {
      return {
        ...state,
        // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'Site'.
        site_detail: initialState.site_detail,
        // @ts-expect-error - TS2739 - Type '{ readonly name: ""; readonly description: ""; readonly entity_type: "candidate_lead"; readonly form_ids: readonly []; readonly url: ""; }' is missing the following properties from type 'SiteLandingPage': id, brand_id
        page: initialState.page,
      };
    }
    case PAGE_SITE_CONSTANTS.UPDATE_SITE_PAGE:
      const updatePayload = action.payload;
      // @ts-expect-error - TS2322 - Type '{ page: { id: string; name?: string; description?: string; entity_type?: string; published?: boolean; final_url?: string; created_by?: string; updated_by?: string; created_at?: string; updated_at?: string; ... 11 more ...; analytics?: { enabled: boolean; type: "GA" | "GTM"; gid: string; }; }; page_sites?: Site[] | u...' is not assignable to type 'PageSiteState'.
      return {
        ...state,
        page: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.page,
          ...updatePayload,
        },
      };
    default:
      // @ts-expect-error - TS2322 - Type 'PageSiteState | null' is not assignable to type 'PageSiteState'.
      return state;
  }
};
